import React from "react";
import { useTheme } from "../../hooks";
import { IconAdorner } from "../icon";
import { StatusTypes } from "./StatusTypes";

type StatusProps = {
  status?: StatusTypes;
  className?: string;
};

const StatusAdorner: React.FC<StatusProps> = ({ status, className }) => {
  const { Theme } = useTheme();
  switch (status) {
    case "success":
      return (
        <IconAdorner
          className={className}
          iconName="fa-check-circle"
          styles={{ color: Theme.colors.green, hoverColor: Theme.colors.green }}
        />
      );
    case "failed":
      return (
        <IconAdorner
          className={className}
          iconName="fa-exclamation-triangle"
          styles={{ color: Theme.colors["mlb-red"], hoverColor: Theme.colors["mlb-red"] }}
        />
      );
    default:
      return <div />;
  }
};

export default StatusAdorner;
